import { useQueryParam, StringParam, withDefault } from 'use-query-params'
import { TranslationDictionary } from '@plandi/common'

export const SORTING_NEW = 'new'
export const SORTING_OLD = 'old'
export const SORTING_PUBLISHED = 'published'
export const SORTING_DRAFT = 'draft'
export const SORTING_CHEAP = 'cheap'
export const SORTING_EXPENSIVE = 'expensive'
export const SORTING_POPULAR = 'max'
export const SORTING_POPULAR_FAVORITE = 'popular'
export const SORTING_DATE_FAVORIT = 'date'
export const SORTING_DATE_STATISTIC = 'date'
export const SORTING_USER_STATISTIC = 'user'
export const SORTING_SPECIALIZATION_STATISTIC = 'specialization'
export const SORTING_READ = 'read'
export const SORTING_UNREAD = 'unread'

//export const SORTING
export const sorting = (translate?: TranslationDictionary['data']): any => {
  return {
    [SORTING_NEW]: translate?.shop['projects-page']['sorting']['first-new'],
    [SORTING_DATE_FAVORIT]:
      translate?.shop['projects-page']['sorting']['first-new'],
    [SORTING_OLD]: translate?.messages['sort-old'],
    [SORTING_PUBLISHED]:
      translate?.shop['my-models-page']['sorting']['first-publish'],
    [SORTING_DRAFT]:
      translate?.shop['my-models-page']['sorting']['first-unpublish'],
    [SORTING_CHEAP]: translate?.shop['projects-page']['sorting']['first-cheap'],
    [SORTING_EXPENSIVE]:
      translate?.shop['projects-page']['sorting']['first-expensive'],
    [SORTING_POPULAR]:
      translate?.shop['my-models-page']['sorting']['first-popular'],
    [SORTING_POPULAR_FAVORITE]:
      translate?.shop['my-models-page']['sorting']['first-popular'],
    [SORTING_DATE_STATISTIC]:
      translate?.shop['my-models-page']['sorting']['first-new'],
    [SORTING_USER_STATISTIC]: translate?.SORTING.user,
    [SORTING_SPECIALIZATION_STATISTIC]: translate?.SORTING.specialization,
    [SORTING_READ]: translate?.messages['sort-is-read'],
    [SORTING_UNREAD]: translate?.messages['sort-is-undread']
  }
}

export const useFilterBySort = () => {
  const [sort, setParam] = useQueryParam(
    'sort',
    withDefault(StringParam, undefined, true)
  )

  const setSorting: typeof setParam = (value) => {
    setParam(value)
  }

  return {
    sort,
    setSorting
  }
}
